import styled from 'styled-components'

export const Container = styled.section`
  margin: 0px auto;
  background: transparent;
  padding: 0px;
  overflow: visible;
  height: ${props => props.auto ? 'auto' : '600px'};
  z-index: 0;
  position: relative;
  left: 0px;
`

export const ContainerImage = styled.div`
  background-image: url(${props => props.image});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  height: 100%;
  padding: 160px 0px;
  opacity: 1;
  visibility: inherit;
  z-index: 20;
`

export const Title = styled.h1`
  font-size: 3rem;
  margin-top: 20px;
  width: 50%;
  color: #fff;
`
